import React, { useState, useEffect } from 'react'
import { Typography, Box, Divider, Button, Stack, CardActionArea, CardActions, Grid, Card, CardContent, CardMedia } from "@mui/material"
import { ReactComponent as LocationIcon } from "../../Icons/location.svg"
import { ReactComponent as FavouritesIcon } from "../../Icons/favouritesIcon.svg"
// import { ReactComponent as ShareIcon } from "../../Icons/ShareIcon.svg"
import Pricing from '../../Components/Hostel/Pricing'
import Service_facilities from '../../Components/Hostel/Service_facilities'
import Views from '../../Components/Hostel/Views'
import Rules from '../../Components/Hostel/Rules'
import Access from '../../Components/Hostel/Access'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios'
import parse from "html-react-parser";
import { useSelector } from 'react-redux'
import ShareIcon from '@mui/icons-material/Share';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next'

export default function HostelReview() {

    const { id } = useParams()

    const [hostelData, setHostelData] = useState([])
    const [loading, setLoading] = useState(false)

    const {t} = useTranslation()

    const [images, setImages] = useState([])

    const language = useSelector((state) => state.language.language)
    const styles = useSelector((state) => state.styles)

    const getHostelById = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}gethostelbyId/${id}`);
            console.log(response?.data);
            setHostelData(response?.data?.data)
            setLoading(false)
        } catch (error) {
            console.log(error);
            setLoading(false)
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

      useEffect(() => {
        if (hostelData?.title?.[language]) {
          document.title = `Vinga | ${hostelData.title[language]}`;
        }
      }, [hostelData, language]);

      useEffect(() => {
        if (hostelData?.images?.[0]?.src) {
          const duplicatedImages = Array(3).fill({
            src: hostelData.images[0].src,
          });
          setImages(duplicatedImages);
        }
      }, [hostelData]);

      console.log(images)

    useEffect(() => {
        getHostelById()
    }, [id])


  const handleShare = async () => {
    const shareData = {
      title: document.title,
      text: 'Check out this page!',
      url: window.location.href,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        console.log('Page shared successfully');
      } catch (err) {
        console.error('Error sharing:', err);
      }
    } else {
      // Fallback: Copy to clipboard
      try {
        await navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard!');
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }
}

if(loading){
  return <p>Loading...</p>
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  centerMode: true,
  centerPadding: "80px",
  arrows: true,
};


  

    return (
        <>
            <Box width="100%">
                <Box sx={{mt : '60px'}} px={{ md: 7, xs: 3 }} >
                    <Stack direction="row" columnGap="10px" alignItems="center">
                        <Typography variant="h7_2" color='#ACACAC' sx={{ cursor: "pointer" }}> {t("Home")}</Typography>
                        <Typography>{'>'}</Typography>
                        <Typography variant="h7_2" color='#007ECA' sx={{ borderBottom: '1px solid #007ECA', cursor: "pointer" }}>{hostelData?.title?.[language]}</Typography>
                    </Stack>
                    <Stack sx={{ mt : '40px'}} direction={{ sm: "row", xs: "column" }} rowGap={2} justifyContent="space-between" alignItems={{ sm: "center", xs: "start" }}>
                        <Stack textAlign="start" gap={1}>
                            <Typography sx={{...styles.h3}}>{hostelData?.title?.[language]}</Typography>
                            <Stack direction="row" alignItems="center" columnGap="10px">
                                <LocationIcon fill='#222222' />
                                <Typography sx={{fontSize : '18px' , color : '#434343'}}>{hostelData?.location?.[language]}</Typography>
                            </Stack>
                        </Stack>
                        <Stack py={2} direction={{ xs: "row" }} columnGap="20px" rowGap={2}>
                            <Button onClick={handleShare} variant="contained" startIcon={<ShareIcon fill="#9E9E9E" />}>Share</Button>
                            {/* <Button variant="contained" sx={{ backgroundColor: "#FFFFFF", borderRadius: "8px", padding: "10px", width: "100px", height: "40px", border: "0.5px solid #9E9E9E", color: "#9E9E9E" }} startIcon={<FavouritesIcon fill="#9E9E9E" />}>Like</Button> */}
                        </Stack>
                    </Stack>
                </Box>

                <Box sx={{display : 'flex', justifyContent :'center', mt : '40px'}}>
                <Box sx={{
                  width : '93%',
                  height : '400px',
                  overflow: "hidden",
                  backgroundImage : `url(${process.env.REACT_APP_FILE_PATH + hostelData?.images?.[0]?.src})`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  borderRadius : '8px'
                }} >

                </Box>
                {/* <Box component={'img'} sx={{width : '70%', borderRadius : '20px'}} src={`${process.env.REACT_APP_FILE_PATH}${hostelData?.images?.[0]?.src}`}> */}
                {/* <Slider {...settings}>
          {images?.map((img, index) => (
            <Box
              key={index}
              component="img"
              src={`${process.env.REACT_APP_FILE_PATH}${img.src}`}
              alt={`Image ${index + 1}`}
              sx={{ width: '100%', borderRadius: '8px', objectFit: 'cover' }}
            />
          ))}
        </Slider> */}
        </Box>
                </Box>

                <Box py={3} px={{ md: 7, xs: 3 }} sx={{mt : '20px'}}>
                    <Stack rowGap="20px">
                        <Typography variant="h6_1">{t("About the Hostel")}</Typography>
                        <Typography variant="h7_2">{Boolean(hostelData?.description?.[language]) ? parse(hostelData?.description?.[language]) : ""}</Typography>
                    </Stack>
                    <Pricing hostelData={hostelData} />
                    <Service_facilities hostelData={hostelData} />
                </Box>
                <Views hostelData={hostelData} />
                <Rules hostelData={hostelData} />
             <Access hostelData={hostelData}/>
            {/* </Box> */}
        </>
    )
}
